
<app-navbar></app-navbar>
<div class="page-title-area page-title-bg1 upper-margin">
    <div class="container">
        <div class="page-title-content">
            <br />
            <br />
            <h2>{{'Terms_and_Conditions' | translate }}</h2>
            <!--<a routerLink="/"> {{'Home' | translate }}</a>-->

        </div>
    </div>
</div>
<!-- End -->
<!-- Start About Area -->
<section class="about-area ptb-100">
    <!-- data-aos="fade-up" data-aos-delay="100"-->
    <div class="container">
        <div class="customer-service-content">
            <div [innerHtml]="PageContentHTML"></div>
        </div>
    </div>
</section>
<!-- End About Area -->
